define(
            'mustache!/home/circleci/project/msproblem/static/jsmvc/ui_components/wistia_video/wistia_video.mustache',
            ['can/util/library', 'can/view/mustache'],
          function(can) { 
            var template = '<div class="flex-video-container {{#if aspect169}}video-aspect-16-9{{/if}}">\n    <div id="wistia_{{videoId}}" class="wistia_embed">&nbsp;</div>\n</div>\n';
            return can.mustache('ui_components_wistia_video_wistia_video_mustache', template);
          });
